import { HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { AssetResponseModel } from 'models/asset';

const assetApi = {
  getAssets: (): Promise<HttpResponse<AssetResponseModel[]>> => {
    const url = `/wallet/api/assets`;
    return handleRequest(axiosClient.get(url));
  },
};

export default assetApi;
